export default {"src":"/_next/static/media/lend.3cd9cc5e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};